export var SCHEDULING_MATRIX_TILE_SIZE;
(function (SCHEDULING_MATRIX_TILE_SIZE) {
    SCHEDULING_MATRIX_TILE_SIZE["m"] = "m";
    SCHEDULING_MATRIX_TILE_SIZE["xl"] = "xl";
    SCHEDULING_MATRIX_TILE_SIZE["xxl"] = "xxl";
})(SCHEDULING_MATRIX_TILE_SIZE || (SCHEDULING_MATRIX_TILE_SIZE = {}));
//# sourceMappingURL=types.js.map